import { createRoot } from 'react-dom/client';
import MainSearchApp from './App/MainSearchApp';
import './css/MainSearch.css';
import { CommunicationManager } from './App/Tools/CommunicationManager';

(function (Drupal, $, once) {
  Drupal.behaviors.loadNovaMainSearchApp = {
    runBehaviorsTimeout: null,

    attach: function (context) {
      const container = once('loadNovaMainSearchApp', '#main_search_app', context);
      if (!container.length) {
        return;
      }
      const root = createRoot(container[0]);
      root.render(<MainSearchApp/>);

      const commManager = new CommunicationManager('headless_search');
      commManager.receiveMessage(() => {
        /**
         * Whenever the React app publishes a message (i.e. searchterm has changed), we want to run the Drupal behaviors on
         * the React app.
         *
         * We use a timeout so that the behaviors won't trigger too-often, for example while someone is typing
         */
        clearTimeout(this.runBehaviorsTimeout);
        this.runBehaviorsTimeout = setTimeout(() => {
          Drupal.attachBehaviors(container[0]);
        }, 700);
      });
    }
  }

})(Drupal, jQuery, once);
